// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1Mmph","label":"Labeled_label__nLbse","divider":"Labeled_divider__uMzbB"};